import { PAYPAL_IDENTITY } from "../Reducers/paypalIdentityReducer";
import { deletePaypalIdentity } from "../Util/queries";

export const deletePaypalIdentityAction = () => async (dispatch) => {
    try {

        await deletePaypalIdentity();

        dispatch({
            type: PAYPAL_IDENTITY,
            payload: null,
        });
    } catch (e) {
        console.error(e);
    }
};